import React from 'react';
import background from '../../assets/shark.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoShark extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="OCEANS"
        subtag="OVERFISHED"
        description="Sharks"
        paragraph="Overfishing and entanglement are damaging shark populations around the world. Sharks grow relatively slowly, take many years to mature and produce relatively few young."
        background={background}
     />
  
  );
 }
}   

export default InfoShark;